import bancos from 'bancos-brasileiros/bancos.json';

function trimCode(value: string | number | undefined | null): string {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).trim();
}

function normalizeIspb(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (!digits) {
    return '';
  }
  return digits.padStart(8, '0');
}

function bankDisplayName(
  banco: (typeof bancos)[number],
  fallback: string,
): string {
  return (banco.ShortName || banco.LongName || fallback).trim();
}

function findByCompe(code: string): (typeof bancos)[number] | undefined {
  if (!code) {
    return undefined;
  }
  return bancos.find(b => String(b.COMPE) === code);
}

function findByIspb(code: string): (typeof bancos)[number] | undefined {
  const normalized = normalizeIspb(code);
  if (!normalized) {
    return undefined;
  }
  return bancos.find(b => normalizeIspb(String(b.ISPB)) === normalized);
}

/**
 * Long/short bank name from BACEN COMPE or ISPB, or the raw code if unknown.
 * Tries COMPE first; when absent or unmatched, falls back to ISPB.
 * Uses string comparison on `COMPE` / padded `ISPB` so numeric codes from the API still match.
 */
export function resolveCompeDisplayName(
  compeCode: string | number | undefined | null,
  ispbCode?: string | number | undefined | null,
): string {
  const compe = trimCode(compeCode);
  const ispb = trimCode(ispbCode);

  const byCompe = findByCompe(compe);
  if (byCompe) {
    return bankDisplayName(byCompe, compe);
  }

  if (ispb) {
    const byIspb = findByIspb(ispb);
    if (byIspb) {
      return bankDisplayName(byIspb, ispb);
    }
  }

  if (compe) {
    const byCompeAsIspb = findByIspb(compe);
    if (byCompeAsIspb) {
      return bankDisplayName(byCompeAsIspb, compe);
    }
    return compe;
  }

  if (ispb) {
    return ispb;
  }

  return '';
}
